webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CHANGE_SHOW_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHANGE_ARTICLE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHANGE_TOPIC_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DISPLAY_ARTICLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGELOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGELOGINWAY; });

var CHANGE_SHOW_STATUS = 'changeShowStatus';
var CHANGE_ARTICLE_LIST = 'changeArticleList';

var CHANGE_TOPIC_SHOW = 'changeTopicShow';
var DISPLAY_ARTICLE = 'displayArticle';
var CHANGELOGIN = 'changeLogin';
var CHANGELOGINWAY = 'changeLoginWay';

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function changeStaticUrl(url) {
    if (true) {
        return url.replace('../../', './');
    }
    return url;
}
/* harmony default export */ __webpack_exports__["a"] = ({
    changeStaticUrl: changeStaticUrl
});

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_article__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_article___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_article__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_topic__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_topic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_topic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_topic_article__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_topic_article___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_topic_article__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_bonus__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_bonus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_bonus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_login__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_download__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_download__);











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	routes: [{
		path: '/',
		component: __WEBPACK_IMPORTED_MODULE_2__components_home___default.a,
		children: [{
			path: '/',
			name: 'Home',
			component: __WEBPACK_IMPORTED_MODULE_3__components_article___default.a
		}]
	}, {
		path: '/topic',
		component: __WEBPACK_IMPORTED_MODULE_4__components_topic___default.a,
		children: [{
			path: '/',
			name: 'Topic',
			component: __WEBPACK_IMPORTED_MODULE_5__components_topic_article___default.a
		}]
	}, {
		path: '/bonus',
		name: 'bonus',
		component: __WEBPACK_IMPORTED_MODULE_6__components_bonus___default.a
	}, {
		path: '/login',
		name: 'login',
		component: __WEBPACK_IMPORTED_MODULE_7__components_login___default.a
	}, {
		path: '/download',
		name: 'download',
		component: __WEBPACK_IMPORTED_MODULE_8__components_download___default.a
	}, {
		path: '*',
		name: 'error',
		redirect: { name: 'Home' }
	}]
});
router.beforeEach(function (to, from, next) {
	next();
});
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_home__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_article__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_topic__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_bonus__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_app__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_login__ = __webpack_require__(22);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
    actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
    getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
    modules: {
        Home: __WEBPACK_IMPORTED_MODULE_4__modules_home__["a" /* default */],
        Article: __WEBPACK_IMPORTED_MODULE_5__modules_article__["a" /* default */],
        Topic: __WEBPACK_IMPORTED_MODULE_6__modules_topic__["a" /* default */],
        bonus: __WEBPACK_IMPORTED_MODULE_7__modules_bonus__["a" /* default */],
        app: __WEBPACK_IMPORTED_MODULE_8__modules_app__["a" /* default */],
        login: __WEBPACK_IMPORTED_MODULE_9__modules_login__["a" /* default */]
    },
    trict: debug
}));

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(43)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(57),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex__ = __webpack_require__(13);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__vuex__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeArticleList", function() { return changeArticleList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeShowStatus", function() { return changeShowStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeTopicShow", function() { return changeTopicShow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeLogin", function() { return changeLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeLoginWay", function() { return changeLoginWay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(2);


var changeArticleList = function changeArticleList(_ref, str) {
	var commit = _ref.commit;

	commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["e" /* CHANGE_ARTICLE_LIST */], str);
};
var changeShowStatus = function changeShowStatus(_ref2, str) {
	var commit = _ref2.commit;

	commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["f" /* CHANGE_SHOW_STATUS */], str);
};

var changeTopicShow = function changeTopicShow(_ref3, str) {
	var commit = _ref3.commit;

	commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* CHANGE_TOPIC_SHOW */], str);
};

var changeLogin = function changeLogin(_ref4) {
	var commit = _ref4.commit;

	commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* CHANGELOGIN */]);
};
var changeLoginWay = function changeLoginWay(_ref5, str) {
	var commit = _ref5.commit;

	commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* CHANGELOGINWAY */], str);
};

/***/ }),
/* 17 */
/***/ (function(module, exports) {



/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(2);



var state = {
    show: 'home',
    loginSuccess: false
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* CHANGELOGIN */], function (state) {
    state.loginSuccess = !state.loginSuccess;
});

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(6);




var articlesAll = {
	fir: {
		author: '徐丹妮',
		title: '我不是学霸，只是比你努力一点而已',
		time: '大约6小时之前',
		read: '8498',
		comment: '248',
		like: '2342',
		pay: '2',
		src: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].changeStaticUrl('url(../../static/vue-demo-hot.jpg)')
	},
	sec: {
		author: '阿俊',
		title: 'Learn by doing',
		time: '大约6小时之前',
		read: '3398',
		comment: '258',
		like: '232',
		pay: '88',
		src: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].changeStaticUrl('url(../../static/vue-demo-new.jpg)')
	},
	thi: {
		author: '尸叔',
		title: '如何让你的自拍，惊爆朋友圈？看我是怎么设计的',
		time: '大约2小时之前',
		read: '3750',
		comment: '70',
		like: '190',
		pay: '0',
		src: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].changeStaticUrl('url(../../static/vue-demo-daily.jpg)')
	}
};
var state = {
	articles: [{
		author: '徐丹妮',
		title: '我不是学霸，只是比你努力一点而已',
		time: '大约6小时之前',
		read: '8498',
		comment: '248',
		like: '2342',
		pay: '2',
		src: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].changeStaticUrl('url(../../static/vue-demo-hot.jpg)')
	}]
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* CHANGE_ARTICLE_LIST */], function (state, str) {
	switch (str) {
		case 'hot':
			state.articles = [articlesAll.fir];
			break;
		case 'new':
			state.articles = [articlesAll.sec];
			break;
		case 'daily':
			state.articles = [articlesAll.thi];
			break;
		default:
			state.articles = [articlesAll.sec];
	}
});

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(6);




var state = {
	texts: {
		Jan: {
			title: '给你90天，成为不一样的自己',
			content_1: "如果你应付不了现在的生活和工作",
			content_2: "无论你走到哪里，",
			content_3: "无论你换了什么工作，什么公司，",
			content_4: "都无济于事。",
			content_5: "因为你根本没想让自己成熟起来，",
			content_6: "想让变的更优秀也不过是一句口头禅。",
			author: '',
			bg: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].changeStaticUrl('url(../../static/bonus_1.jpg)')
		},
		Feb: {
			title: '使你更有思想的20本书',
			content_1: "真正伟大的当代文学，",
			content_2: "正如人们借由狄更斯来了解十九世纪的英国，",
			content_3: "后人也可以通过《自由》来了解",
			content_4: "二十一世纪初期的美国。",
			content_5: "",
			content_6: "",
			author: '',
			bg: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].changeStaticUrl('url(../../static/bonus_2.jpg)')
		},
		Mar: {
			title: '无感是最舒适的爱情',
			content_1: "爱情原本就是个很娇气的东西，",
			content_2: "它经不起太多的矫情，你死我活和无理取闹，",
			content_3: "也经不起任何的伪装，刻意讨好和忍辱负重。",
			content_4: "当她拂去所有的惊喜，荣幸，不敢置信和小心翼翼，",
			content_5: "才是爱情最原本的样子。",
			content_6: "当她不再刻意的感受他的存在，",
			author: '',
			bg: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].changeStaticUrl('url(../../static/bonus_3.jpg)')
		},
		Apr: {
			title: '无感是最舒适的爱情',
			content_1: "爱情原本就是个很娇气的东西，",
			content_2: "它经不起太多的矫情，你死我活和无理取闹，",
			content_3: "也经不起任何的伪装，刻意讨好和忍辱负重。",
			content_4: "当她拂去所有的惊喜，荣幸，不敢置信和小心翼翼，",
			content_5: "才是爱情最原本的样子。",
			content_6: "当她不再刻意的感受他的存在，",
			author: '',
			bg: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].changeStaticUrl('url(../../static/bonus_4.jpg)')
		},
		May: {
			title: '无感是最舒适的爱情',
			content_1: "爱情原本就是个很娇气的东西，",
			content_2: "它经不起太多的矫情，你死我活和无理取闹，",
			content_3: "也经不起任何的伪装，刻意讨好和忍辱负重。",
			content_4: "当她拂去所有的惊喜，荣幸，不敢置信和小心翼翼，",
			content_5: "才是爱情最原本的样子。",
			content_6: "当她不再刻意的感受他的存在，",
			author: '',
			bg: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].changeStaticUrl('url(../../static/bonus_5.jpg)')
		},
		Jun: {
			title: '无感是最舒适的爱情',
			content_1: "爱情原本就是个很娇气的东西，",
			content_2: "它经不起太多的矫情，你死我活和无理取闹，",
			content_3: "也经不起任何的伪装，刻意讨好和忍辱负重。",
			content_4: "当她拂去所有的惊喜，荣幸，不敢置信和小心翼翼，",
			content_5: "才是爱情最原本的样子。",
			content_6: "当她不再刻意的感受他的存在，",
			author: '',
			bg: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].changeStaticUrl('url(../../static/bonus_6.jpg)')
		},
		Jul: {
			title: '无感是最舒适的爱情',
			content_1: "爱情原本就是个很娇气的东西，",
			content_2: "它经不起太多的矫情，你死我活和无理取闹，",
			content_3: "也经不起任何的伪装，刻意讨好和忍辱负重。",
			content_4: "当她拂去所有的惊喜，荣幸，不敢置信和小心翼翼，",
			content_5: "才是爱情最原本的样子。",
			content_6: "当她不再刻意的感受他的存在，",
			author: '',
			bg: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].changeStaticUrl('url(../../static/bonus_7.jpg)')
		},
		Aug: {
			title: '无感是最舒适的爱情',
			content_1: "爱情原本就是个很娇气的东西，",
			content_2: "它经不起太多的矫情，你死我活和无理取闹，",
			content_3: "也经不起任何的伪装，刻意讨好和忍辱负重。",
			content_4: "当她拂去所有的惊喜，荣幸，不敢置信和小心翼翼，",
			content_5: "才是爱情最原本的样子。",
			content_6: "当她不再刻意的感受他的存在，",
			author: '',
			bg: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].changeStaticUrl('url(../../static/bonus_8.jpg)')
		},
		Sep: {
			title: '无感是最舒适的爱情',
			content_1: "爱情原本就是个很娇气的东西，",
			content_2: "它经不起太多的矫情，你死我活和无理取闹，",
			content_3: "也经不起任何的伪装，刻意讨好和忍辱负重。",
			content_4: "当她拂去所有的惊喜，荣幸，不敢置信和小心翼翼，",
			content_5: "才是爱情最原本的样子。",
			content_6: "当她不再刻意的感受他的存在，",
			author: '',
			bg: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].changeStaticUrl('url(../../static/bonus_9.jpg)')
		},
		Oct: {
			title: '无感是最舒适的爱情',
			content_1: "爱情原本就是个很娇气的东西，",
			content_2: "它经不起太多的矫情，你死我活和无理取闹，",
			content_3: "也经不起任何的伪装，刻意讨好和忍辱负重。",
			content_4: "当她拂去所有的惊喜，荣幸，不敢置信和小心翼翼，",
			content_5: "才是爱情最原本的样子。",
			content_6: "当她不再刻意的感受他的存在，",
			author: '',
			bg: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].changeStaticUrl('url(../../static/bonus_10.jpg)')
		},
		Nov: {
			title: '无感是最舒适的爱情',
			content_1: "爱情原本就是个很娇气的东西，",
			content_2: "它经不起太多的矫情，你死我活和无理取闹，",
			content_3: "也经不起任何的伪装，刻意讨好和忍辱负重。",
			content_4: "当她拂去所有的惊喜，荣幸，不敢置信和小心翼翼，",
			content_5: "才是爱情最原本的样子。",
			content_6: "当她不再刻意的感受他的存在，",
			author: '',
			bg: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].changeStaticUrl('url(../../static/bonus_11.jpg)')
		},
		Dec: {
			title: '无感是最舒适的爱情',
			content_1: "爱情原本就是个很娇气的东西，",
			content_2: "它经不起太多的矫情，你死我活和无理取闹，",
			content_3: "也经不起任何的伪装，刻意讨好和忍辱负重。",
			content_4: "当她拂去所有的惊喜，荣幸，不敢置信和小心翼翼，",
			content_5: "才是爱情最原本的样子。",
			content_6: "当她不再刻意的感受他的存在，",
			author: '',
			bg: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].changeStaticUrl('url(../../static/bonus_12.jpg)')
		}
	}
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* DISPLAY_ARTICLE */], function (state, str) {
	state.currentArticles = str;
});

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(2);



var state = {
    show: 'hot'
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* CHANGE_SHOW_STATUS */], function (state, str) {
    state.show = str;
});

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(2);



var state = {
    loginway: 'login',
    user: ''
};
var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* CHANGELOGINWAY */], function (state, str) {
    console.log(str);
    state.loginway = str;
});

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(6);


var _mutations;




var state = {
	topics: {
		fir: {
			img: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].changeStaticUrl('../../static/topic_1.jpg'),
			title: '游戏',
			par: '玩转简书的第一步，从这个专题开始。\
				  想上首页热门榜么？好内容想被更多人看到么？来投稿吧！\
				  如果被拒也不要灰心哦～入选文章会进一个队列挨个上首页，请耐心等待。\
				  投稿必须原创。如果发现有非...',
			number: '97233',
			concern: '121.7',
			keys: '故事、连载',
			time: '20160620'
		},
		sec: {
			img: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].changeStaticUrl('../../static/topic_3.jpg'),
			title: '诗',
			par: '诗，让你感受自己的心灵。\
				 专题主编：苏锦年 投稿须知：\
				 1.本专题收录古诗、词、现代诗以及诗词点评及指导。\
                 2.内容必须为原创，切勿用其他诗人的诗句。\
                 3.文章排版整洁，注意...',
			number: '35420',
			concern: '146.6',
			keys: '诗',
			time: '20160630'
		}
	},
	show: 'hot'
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* DISPLAY_ARTICLE */], function (state, str) {
	state.currentArticles = str;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* CHANGE_TOPIC_SHOW */], function (state, str) {
	state.show = str;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
	state: state,
	mutations: mutations
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            show: 'home'
        };
    },
    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapState */])({
        login_success: function login_success(state) {
            return state.app.login_success;
        }
    }),
    method: {
        changeLogin: function changeLogin(str) {
            this.$store.dispatch('changeLoginWay', str);
        },
        changeShow: function changeShow(str) {
            this.show = str;
        }
    },
    watch: {
        '$route': function $route(to, from) {
            if (to.name) {
                this.show = to.name.toLowerCase();
            }
            if (to.params.loginWay) {
                this.$store.dispatch('changeLoginWay', to.params.loginWay);
            }
        }
    }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
	computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapState */])({
		articles: function articles(state) {
			return state.Article.articles;
		}
	}),
	methods: {
		pushArticleInfo: function pushArticleInfo() {
			this.$router.push({ name: 'Home', params: { articleId: 123 } });
		}
	}
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
	computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapState */])({
		articles: function articles(state) {
			this.texts = state.bonus.texts;
			return [this.texts.Jan, this.texts.Feb, this.texts.Mar, this.texts.Apr, this.texts.May, this.texts.Jun, this.texts.Jul, this.texts.Aug, this.texts.Sep, this.texts.Oct, this.texts.Nov, this.texts.Dec];
		}
	})
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
	computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapState */])({
		show: function show(state) {
			return state.Home.show;
		}
	}),
	methods: {
		displayArticle: function displayArticle(str) {
			this.$store.dispatch('changeShowStatus', str);
			this.$store.dispatch('changeArticleList', str);
		}
	}
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		var checked = 'true';
		var username = void 0;
		var password = void 0;
		return { checked: checked, username: username, password: password };
	},

	computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapState */])({
		loginway: function loginway(state) {
			return state.login.loginway;
		},
		user: function user(state) {
			return state.login.user;
		},
		login_success: function login_success(state) {
			return state.app.login_success;
		}
	}),
	methods: {
		changeLoginWay: function changeLoginWay(str) {
			this.$store.dispatch('changeLoginWay', str);
		},
		verify: function verify() {
			if (this.username == user.name && this.password == user.password) {
				login_success = 'true';
			} else {
				alert('password or username is not correct,please try again!');
			}
		}
	}
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapState */])({
    show: function show(state) {
      return state.Topic.show;
    }
  }),
  methods: {
    changeTopicShow: function changeTopicShow(str) {
      this.$store.dispatch('changeTopicShow', str);
    }
  }
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		var change = 'hot';
		return { change: change };
	},

	computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapState */])({
		topic: function topic(state) {
			return state.Topic.topics;
		},
		show: function show(state) {
			return state.Topic.show;
		}
	}),
	method: {
		sortContent: function sortContent() {
			this.$store.dispatch('sortContent');
		}
	}
});

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 44 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 45 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 46 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(44)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(58),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(46)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(61),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(48)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(63),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(45)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(27),
  /* template */
  __webpack_require__(60),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(49)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(28),
  /* template */
  __webpack_require__(64),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(29),
  /* template */
  __webpack_require__(59),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(47)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(30),
  /* template */
  __webpack_require__(62),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('ul', {
    staticClass: "dropdown"
  }, [_c('li', {
    class: {
      active: _vm.show === 'home'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    },
    on: {
      "click": function($event) {
        _vm.changeShow('home')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _c('span', [_vm._v("  首页")])])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.show === 'topic'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Topic'
      }
    },
    on: {
      "click": function($event) {
        _vm.changeShow('topic')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-th"
  }), _c('span', [_vm._v("  专题")])])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.show === 'download'
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/download'
    },
    on: {
      "click": function($event) {
        _vm.changeShow('download')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-mobile"
  }), _c('span', [_vm._v("  下载手机应用")])])], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "nav-user"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/test"
    }
  }, [_c('i', {
    staticClass: "fa fa-font"
  }), _c('span', [_vm._v("  显示模式")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-in"
  }), _c('span', [_vm._v("  登录")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "home",
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "display"
    }
  }, [_c('router-view', {
    attrs: {
      "transition": "display",
      "transition-mode": "out-in"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "rightbar"
  }, [(!_vm.login_success) ? _c('nav', [_c('router-link', {
    attrs: {
      "to": {
        name: 'login',
        params: {
          loginWay: 'login'
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-in"
  }), _vm._v("登录")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login',
        params: {
          loginWay: 'register'
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v("注册")])], 1) : _vm._e(), _vm._v(" "), (_vm.login_success == 'true') ? _c('nav', [_c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    },
    on: {
      "click": function($event) {
        _vm.changeLogin('login')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-in"
  }), _vm._v("个人信息")])], 1) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', _vm._l((_vm.articles), function(article) {
    return _c('li', {
      staticClass: "list",
      on: {
        "click": function($event) {
          _vm.pushArticleInfo()
        }
      }
    }, [_c('p', {
      staticClass: "list-top"
    }, [_c('a', {
      staticClass: "author",
      attrs: {
        "href": "#"
      }
    }, [_c('span', [_vm._v(_vm._s(article.author))])]), _c('span', {
      staticClass: "time"
    }, [_vm._v(" - " + _vm._s(article.time))])]), _vm._v(" "), _c('h2', {
      staticClass: "title"
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(article.title))])]), _vm._v(" "), _c('div', {
      staticClass: "small-text-group"
    }, [_c('span', {
      staticClass: "small-text"
    }, [_vm._v("阅读 " + _vm._s(article.read) + " -")]), _vm._v(" "), _c('span', {
      staticClass: "small-text"
    }, [_vm._v("评论 " + _vm._s(article.comment) + " -")]), _vm._v(" "), _c('span', {
      staticClass: "small-text"
    }, [_vm._v("喜欢 " + _vm._s(article.like) + " -")]), _vm._v(" "), _c('span', {
      staticClass: "small-text"
    }, [_vm._v("打赏 " + _vm._s(article.pay))])]), _vm._v(" "), _c('span', {
      staticClass: "image",
      style: ({
        backgroundImage: article.src,
        backgroundSize: '100%',
        backgroundRepeat: 'no-repat'
      })
    })])
  }))
},staticRenderFns: []}

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "article-page"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "article-list"
  }, [_c('ul', {
    staticClass: "btn-group"
  }, [_c('li', {
    class: {
      active: _vm.show === 'hot'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.changeTopicShow('hot')
      }
    }
  }, [_vm._v("热门")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.show === 'recommend'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.changeTopicShow('recommend')
      }
    }
  }, [_vm._v("推荐")])])])]), _vm._v(" "), _c('router-view')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "showbar"
  }, [_c('div', {
    staticClass: "cover-image_2"
  }), _vm._v(" "), _c('div', {
    staticClass: "text",
    staticStyle: {
      "text-shadow": "1px 1px 1px #000000"
    }
  }, [_c('h1', [_vm._v("专题")]), _vm._v(" "), _c('h3', [_vm._v("让思想汇聚，流传")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "14px",
      "margin-bottom": "5px"
    }
  }, [_vm._v("专题内容由多位写作者提供")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v("  新建专题")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('span', {
    staticClass: "search clearfloat"
  }, [_c('span', {
    staticClass: "input"
  }, [_c('input', {
    attrs: {
      "type": "search",
      "placeholder": "搜索"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "search-icon"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])
}]}

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "article-page"
  }, [_c('nav', [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'bonus'
      }
    }
  }, [_vm._v("2015精选")])], 1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "article-list clearfix"
  }, [_c('ul', {
    staticClass: "btn-group"
  }, [_c('li', {
    class: {
      active: _vm.show === 'hot'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.displayArticle('hot')
      }
    }
  }, [_vm._v("热门")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.show === 'new'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.displayArticle('new')
      }
    }
  }, [_vm._v("新上榜")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.show === 'daily'
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.displayArticle('daily')
      }
    }
  }, [_vm._v("日报")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.show === 'weekhot'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    },
    on: {
      "click": function($event) {
        _vm.show = 'weekhot'
      }
    }
  }, [_vm._v("七日热门")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.show === 'monthhot'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    },
    on: {
      "click": function($event) {
        _vm.show = 'monthhot'
      }
    }
  }, [_vm._v("三十日热门")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.show === 'reward'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    },
    on: {
      "click": function($event) {
        _vm.show = 'reward'
      }
    }
  }, [_vm._v("有奖活动")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.show === 'publish'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    },
    on: {
      "click": function($event) {
        _vm.show = 'publish'
      }
    }
  }, [_vm._v("简书出版")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.show === 'video'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    },
    on: {
      "click": function($event) {
        _vm.show = 'vedio'
      }
    }
  }, [_vm._v("简书播客")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.show === 'hotnews'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    },
    on: {
      "click": function($event) {
        _vm.show = 'hotnews'
      }
    }
  }, [_vm._v("时事热闻")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.show === 'choice'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    },
    on: {
      "click": function($event) {
        _vm.show = 'choice'
      }
    }
  }, [_vm._v("专题精选")])], 1)]), _vm._v(" "), _c('router-view')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "showbar"
  }, [_c('div', {
    staticClass: "cover-image"
  }), _vm._v(" "), _c('div', {
    staticClass: "text",
    staticStyle: {
      "text-shadow": "1px 1px 1px #000000"
    }
  }, [_c('h1', [_vm._v("简书")]), _vm._v(" "), _c('h3', [_vm._v("交流故事，沟通想法")]), _vm._v(" "), _c('p', [_vm._v("一个基于内容分享的社区")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("提笔写篇文章")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nav-text fir"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("发现")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "search clearfloat"
  }, [_c('span', {
    staticClass: "input"
  }, [_c('input', {
    attrs: {
      "type": "search",
      "placeholder": "搜索"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "search-icon"
  }, [_c('i', {
    staticClass: "fa fa-seaSrch"
  })])])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bonus-container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "text-list"
  }, _vm._l((_vm.articles), function(article) {
    return _c('li', {
      style: ({
        background: article.bg,
        backgroundSize: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#ffffff'
      })
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "bonus-text"
    }, [_c('div', {
      staticClass: "bonus-text-title"
    }, [_vm._v(_vm._s(article.title))]), _vm._v(" "), _c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('div', {
      staticClass: "bonus-text-content"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(article.content_1)), _c('br'), _vm._v("\n\t\t\t\t\t\t" + _vm._s(article.content_2)), _c('br'), _vm._v("\n\t\t\t\t\t\t" + _vm._s(article.content_3)), _c('br'), _vm._v("\n\t\t\t\t\t\t" + _vm._s(article.content_4)), _c('br'), _vm._v("\n\t\t\t\t\t\t" + _vm._s(article.content_5)), _c('br'), _vm._v("\n\t\t\t\t\t\t" + _vm._s(article.content_6)), _c('br')])]), _vm._v(" "), _c('div', {
      staticClass: "author"
    })])])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bonus-header"
  }, [_c('span', {
    staticClass: "yellow"
  }, [_vm._v("  简书2015")]), _vm._v(" "), _c('i', [_vm._v(" · ")]), _vm._v(" "), _c('span', [_vm._v("每月一篇好文章  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "share"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-mobile"
  }), _vm._v("手机查看效果更佳")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-weibo"
  }), _vm._v("分享到微博")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-wechat"
  }), _vm._v("分享到微信")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("更多分享")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "mask",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "button"
  }, [_vm._v("阅读全文>")])])
}]}

/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topic_article_container"
  }, [(_vm.show === 'recommend') ? _c('div', {
    staticClass: "sequence-nav"
  }, [_c('a', {
    class: {
      active: _vm.change === 'new'
    },
    on: {
      "click": function($event) {
        _vm.sortContent('time'), _vm.change = 'new'
      }
    }
  }, [_vm._v("最新更新  ·")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.change === 'hot'
    },
    on: {
      "click": function($event) {
        _vm.change = 'hot'
      }
    }
  }, [_vm._v("热门排序  ·")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.change === 'concern'
    },
    on: {
      "click": function($event) {
        _vm.sortContent('concern'), _vm.change = 'new'
      }
    }
  }, [_vm._v("关注度排序")])]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.topic), function(content) {
    return _c('li', [_c('a', {
      staticClass: "topic_article_img",
      attrs: {
        "href": ""
      }
    }, [_c('img', {
      attrs: {
        "src": content.img
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "topic_content"
    }, [_c('h5', [_vm._v(_vm._s(content.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(content.par))]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('p', [_c('a', {
      staticStyle: {
        "color": "#4094c7"
      },
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(content.number) + "篇文章")]), _vm._v("\n\t\t\t\t\t  ·  " + _vm._s(content.concern) + "k人关注\n\t\t\t\t\t"), _c('span', {
      staticClass: "topic_tag"
    }, [_c('i', {
      staticClass: "fa fa-tags"
    }), _vm._v(_vm._s(content.keys))])])])])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topic_button"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus"
  }), _c('span', [_vm._v("添加关注")])])])
}]}

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download_container"
  }, [_c('div', {
    staticClass: "download_content"
  }, [_c('div', {
    staticClass: "page-left"
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "download_btn"
  }, [_c('ul', {
    staticClass: "download"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-android"
  }), _vm._v("Android版")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-mobile"
  }), _vm._v("iPhone版")])])]), _vm._v(" "), _c('div', {
    staticClass: "download_img1"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "share_list"
  }, [_c('li', [_vm._v("关注我们")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-qq"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-weibo"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-wechat"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "app-img"
  })])])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-container"
  }, [_c('div', {
    staticClass: "login-logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "login-header"
  }, [_c('a', {
    class: {
      active: _vm.loginway == 'login'
    },
    on: {
      "click": function($event) {
        _vm.changeLoginWay('login')
      }
    }
  }, [_vm._v("    登录    ·")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.loginway == 'register'
    },
    on: {
      "click": function($event) {
        _vm.changeLoginWay('register')
      }
    }
  }, [_vm._v("    注册    ")])]), _vm._v(" "), (_vm.loginway === 'login') ? _c('div', {
    staticClass: "login-input"
  }, [_c('form', {
    staticClass: "form_login",
    attrs: {
      "action": "http://localhost:5480/WebApp/login.php",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "username"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "span2",
    attrs: {
      "type": "text",
      "name": "register_name",
      "placeholder": "选一个昵称"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "password"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "span2",
    attrs: {
      "type": "password",
      "name": "register_password",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "login-btn btn",
    on: {
      "click": _vm.verify
    }
  }, [_c('span', [_vm._v("登录")])]), _vm._v(" "), _c('div', {
    staticClass: "login-control",
    staticStyle: {
      "color": "#555555",
      "font-size": "12px"
    }
  }, [_c('span', {
    staticClass: "checkbox",
    class: {
      checked: _vm.checked === true
    },
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        _vm.checked = !_vm.checked
      }
    }
  }, [_c('input', {
    staticStyle: {
      "position": "absolute",
      "opacity": "0"
    },
    attrs: {
      "type": "checkbox",
      "checked": "checked"
    }
  }), _vm._v(" "), _c('ins', {
    staticClass: "check"
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("记住我")]), _vm._v(" "), _vm._m(2)])])]) : _vm._e(), _vm._v(" "), (_vm.loginway === 'register') ? _c('div', {
    staticClass: "login-input"
  }, [_vm._m(3)]) : _vm._e(), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "span1"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "span1"
  }, [_c('i', {
    staticClass: "fa fa-unlock-alt"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#555555"
    },
    attrs: {
      "href": "#"
    }
  }, [_vm._v("忘记密码")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form_register",
    attrs: {
      "method": "post",
      "action": "http://localhost:5480/WebApp/register.php"
    }
  }, [_c('div', {
    staticClass: "email"
  }, [_c('span', {
    staticClass: "span1"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  })]), _vm._v(" "), _c('input', {
    staticClass: "span2",
    attrs: {
      "type": "text",
      "name": "email_adress",
      "placeholder": "你的邮件地址"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "username"
  }, [_c('span', {
    staticClass: "span1"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })]), _vm._v(" "), _c('input', {
    staticClass: "span2",
    attrs: {
      "type": "text",
      "name": "sign_in[name]",
      "placeholder": "手机号码/电子邮件"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "password"
  }, [_c('span', {
    staticClass: "span1"
  }, [_c('i', {
    staticClass: "fa fa-unlock-alt"
  })]), _vm._v(" "), _c('input', {
    staticClass: "span2",
    attrs: {
      "type": "password",
      "name": "sign_in[password]",
      "placeholder": "密码"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "register-btn btn",
    attrs: {
      "type": "submit"
    }
  }, [_c('span', [_vm._v("注册")])]), _vm._v(" "), _c('p', {
    staticClass: "register_text"
  }, [_vm._v("点击 “注册” 或下方社交登录按钮，即表示您同意并愿意遵守简书 "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("用户协议")]), _vm._v(" 和 "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("隐私政策")]), _vm._v(" 。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-way"
  }, [_c('h5', [_vm._v("您还可以通过以下方式登录")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "qqicon"
  }, [_c('i', {
    staticClass: "fa fa-qq"
  })]), _vm._v(" "), _c('li', {
    staticClass: "weiboicon"
  }, [_c('i', {
    staticClass: "fa fa-weibo"
  })]), _vm._v(" "), _c('li', {
    staticClass: "wechaticon"
  }, [_c('i', {
    staticClass: "fa fa-wechat"
  })]), _vm._v(" "), _c('li', {
    staticClass: "googleicon"
  }, [_c('i', {
    staticClass: "fa fa-google-plus"
  })]), _vm._v(" "), _c('li', {
    staticClass: "githubicon"
  }, [_c('i', {
    staticClass: "fa fa-github"
  })])])])
}]}

/***/ })
],[15]);


// WEBPACK FOOTER //
// static/js/app.cd487954d2a910962efd.js